import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Button, Text } from '@frontend/design-system';
import Star from '../../assets/Star.png';

type FavoritesBannerProps = {
  onManageFavorites: () => void;
};

export const FavoritesBanner = ({ onManageFavorites }: FavoritesBannerProps) => {
  const { t } = useTranslation('insuranceEligibilityReport');
  return (
    <div css={bannerTextStyles}>
      <img src={Star} css={{ width: '32px', height: '32px' }} alt={t('Favorite Icon')} />
      <header>
        <Text size='medium' weight='bold'>
          {t('Introducing Favorite Procedures')}
        </Text>
        <Text size='small'>{t('Add your frequently used CDT codes as favorites for quick access.')}</Text>
      </header>
      <aside css={{ marginLeft: 'auto' }}>
        <Button variant='tertiary' iconName='plus' onClick={onManageFavorites}>
          {t('Add Favorites')}
        </Button>
      </aside>
    </div>
  );
};

const bannerTextStyles = css({
  width: '100%',
  height: '72px',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(1),
  padding: theme.spacing(2),
  border: `1px solid ${theme.colors.warning40}`,
  borderRadius: theme.borderRadius.small,
  backgroundColor: theme.colors.warning5,
  marginBottom: theme.spacing(2),
});
